import { Link } from 'gatsby'
import React from 'react'
import { useLink } from '../../hooks/useLink'

const DynamicLink = ({ link, append = '', ...props }) => {
  const { url, label } = useLink(link)

  if (
    ['http', 'https', 'mailto'].some(externalPrefix =>
      url.startsWith(externalPrefix),
    )
  ) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" {...props}>
        {label}
      </a>
    )
  }

  return (
    <Link to={`${url}${append}`} {...props}>
      {label}
    </Link>
  )
}

export default DynamicLink
